import { useEffect, useState } from 'react';

/**
 * The value, held back until it has stopped changing for `delayMs`.
 *
 * Trailing edge only: a burst of typing collapses into one update, and nothing is requested
 * for a prefix the user never stopped on.
 */
export const useDebouncedValue = <T>(value: T, delayMs: number): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
};
